/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Add_Speaker_TitleInputs */

const en_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Speaker`)
};

const fr_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un intervenant`)
};

const de_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecher hinzufügen`)
};

const it_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi altoparlante`)
};

const ru_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить динамик`)
};

const es_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar orador`)
};

const zh_cn2_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加发言人`)
};

const ja_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを追加`)
};

const hi_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर जोड़ें`)
};

const pt_pt2_speakers_add_speaker_title = /** @type {(inputs: Speakers_Add_Speaker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar alto-falante`)
};

/**
* | output |
* | --- |
* | "Add Speaker" |
*
* @param {Speakers_Add_Speaker_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_add_speaker_title = /** @type {((inputs?: Speakers_Add_Speaker_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Add_Speaker_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_add_speaker_title(inputs)
	if (locale === "de") return de_speakers_add_speaker_title(inputs)
	if (locale === "it") return it_speakers_add_speaker_title(inputs)
	if (locale === "ru") return ru_speakers_add_speaker_title(inputs)
	if (locale === "es") return es_speakers_add_speaker_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_add_speaker_title(inputs)
	if (locale === "ja") return ja_speakers_add_speaker_title(inputs)
	if (locale === "hi") return hi_speakers_add_speaker_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_add_speaker_title(inputs)
	return en_speakers_add_speaker_title(inputs)
});